import React, {FC, useEffect} from "react";
import {Col, DatePicker, Form, Input, Row, Select} from "antd";
import Button from "mixins/ui/button/button";
import {AdminContentManagement} from "../admin-content-management.type";
import FilterProps = AdminContentManagement.FilterProps;

const FilterForm: FC<FilterProps> = (props: FilterProps) => {
    const [form] = Form.useForm();

    const statusList = [
        { value: 'EQUAL', label: 'Опубликовано' },
        { value: 'NEW', label: 'Не опубликовано' },
    ];

    const contentTypeList = [
        { value: 'page-kgd', label: 'Страница КГД' },
    ];

    const onFinish = (values: any) => {
        props.extendedSearch(values)
    };

    const clear = () => {
        form.resetFields();
        props.clear();
    };

    useEffect(() => {
        form.setFieldValue('search', props.search);
    }, [props.search]);

    return (
        <Form form={form} className="my-3 filter-content" layout="vertical" onFinish={onFinish}>
            <Row gutter={15}>
                <Col span={12}>
                    <Form.Item label="Наименование" name="search">
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Тип контента" name="contentType">
                        <Select options={contentTypeList} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Автор" name="author">
                        <Input />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Статус" name="status">
                        <Select options={statusList} />
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label="Последнее изменение" name="changeDate">
                        <DatePicker picker="date" />
                    </Form.Item>
                </Col>
            </Row>

            <hr className="mb-4" />

            <Row gutter={15}>
                <Col>
                    <Button onClick={clear}>Очистить</Button>
                </Col>
                <Col>
                    <Button type="primary" htmlType="submit" color="gold">Применить</Button>
                </Col>
            </Row>
        </Form>
    );
};

export default FilterForm;
